import React, { useCallback, useState } from 'react';
import Dialog from '../Dialog';

export function useDeleteConfirmation(onDelete, dialogProps = {}) {
  const [data, setData] = useState(null);
  const open = useCallback((data) => {
    setData(data);
  }, []);
  const handleClose = useCallback(() => setData(null), []);
  const { entityName = 'объект', ...otherDialogProps } = dialogProps;

  const dialog = (
    <Dialog
      title={`Вы уверены, что хотите удалить ${entityName}?`}
      handleAccept={() => {
        handleClose();
        onDelete(data);
      }}
      open={!!data}
      handleClose={handleClose}
      {...otherDialogProps}
    />
  );

  return [dialog, open];
}
